<script lang="ts">
  import { onMount } from "svelte";
  import { getStoresContext } from "~/stores";

  export let id = 0; // boolean
  export let request_store_key;
  const { T } = getStoresContext(request_store_key);
  $: t = $T;


  let dialog: HTMLDialogElement; // HTMLDialogElement

  $: if (dialog && id) dialog.showModal();
  let body: HTMLBodyElement;
  onMount(() => {
    body = document.getElementsByTagName("body")[0];
  });

  $: {
    if (dialog && id && body) {
      body.classList.add("overflow-hidden");
    } else if (body && !id) {
      body.classList.remove("overflow-hidden");
    }
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<dialog
  bind:this={dialog}
  on:close={() => (id = 0)}
  on:click|self={() => dialog.close()}
>
  <div class="m-auto" on:click|stopPropagation>
    <slot />
    <button class="close" on:click={() => dialog.close()}>
      <span class="d-lg-none">{t`close`}</span>
      <img src="/theme/citycon2023/images/close-icon.png" alt="close" width="32" />
    </button>
  </div>
</dialog>

<style lang="scss">
  .close {
    right: 19px;
    position: absolute;
    top: -40px;
    transition: all 0.2s ease;
    display: flex;
    span {
      color: var(--color-white);
      margin-right: 5px;
    }
    @media screen and (min-width: 992px) {
      right: -50px;
      position: absolute;
      top: 0;
      display: block;
    }
  }
  .close:hover {
    transform: scale(1.2);
  }
  dialog {
    overflow: visible;
    padding: 0;

    div {
      max-width: calc(100vw - 50px);
      width: 420px;
      background-color: #ffffff;
      max-height: 71vh;
      overflow: auto;

      @media screen and (min-width: 768px) {
        max-height: 90vh;
      }
    }
  }
  dialog::backdrop {
    background: rgba(0, 0, 0, 0.75);
  }

  dialog[open] {
    animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  @keyframes zoom {
    from {
      transform: scale(0.95);
    }
    to {
      transform: scale(1);
    }
  }
  dialog[open]::backdrop {
    animation: fade 0.2s ease-out;
  }
  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  button {
    display: block;
  }
</style>
